import { Injectable } from '@angular/core';
import { cloneDeep, merge } from 'lodash';
import { AlertService } from '../../alert/alert.service';
import { ConfigService } from '../config.service';
import { PipelineConfig } from './pipeline-config.model';
import { PIPELINE_DEFAULT_CONFIG } from './pipeline-defualt-config.const';

@Injectable()
export class PipelineConfigService {
  private cachedConfig: PipelineConfig | null = null;
  private lastConfigReference: unknown = null;

  constructor(
    private readonly configService: ConfigService,
    private readonly alertService: AlertService,
  ) {}

  public getConfig(): PipelineConfig {
    try {
      const currentPipelineConfig = this.configService.getConfig().pipeline;

      if (this.cachedConfig && this.lastConfigReference === currentPipelineConfig) {
        return this.cachedConfig;
      }

      const defaultConfig = cloneDeep(PIPELINE_DEFAULT_CONFIG);
      const mergedConfig = merge(defaultConfig, currentPipelineConfig);

      this.cachedConfig = mergedConfig;
      this.lastConfigReference = currentPipelineConfig;

      return mergedConfig;
    } catch (e: unknown) {
      this.alertService.error('Configuration for Pipeline is not available. See config.json section pipeline');
      throw e;
    }
  }
}
